import { getSDKClientGlobal, fallbackConfig } from './utils/SDKClientGlobalUtils'

const ensureClientLibraryIsSet = () =>
  new Promise((resolve) => {
    let attemptCount = 0
    const waitForSDKClient = () => {
      if (getSDKClientGlobal()?.clientLibraryInstance) return resolve()
      if (attemptCount < 30) {
        setTimeout(waitForSDKClient, 100)
        attemptCount += 1
      } else {
        throw Error(`[Credible ${fallbackConfig?.appName}] - Can't find SDKClient global store`)
      }
    }
    waitForSDKClient()
  })

const sentMessage = async (message, ...data) => {
  try {
    await ensureClientLibraryIsSet()
  } catch (e) {
    console.warn(e)
    return
  }
  const {
    clientLibraryInstance: { sendMessage },
  } = getSDKClientGlobal()

  sendMessage(message, ...data)
}

const listenOnce = async (message, cb) => {
  try {
    await ensureClientLibraryIsSet()
  } catch (e) {
    console.warn(e)
    return
  }
  const {
    clientLibraryInstance: { listenOnce },
  } = getSDKClientGlobal()

  listenOnce(message, cb)
}

export default {
  sentMessage,
  listenOnce,
}
